// Initialize price handler
const priceHandler = new PriceHandler()

/**
 * Update all server-side GTM plan prices using original prices from data attributes
 */
function updateServerSideGtmPlansPrices() {
    // Support legacy table (if still present)
    const legacyPriceElements = document.querySelectorAll('.plans .table .price[data-price-bgn]')
    legacyPriceElements.forEach((priceElement) => {
        priceHandler.updateElementWithOriginalPrices(priceElement)
    })

    // Update card prices with monthly prices (default)
    const cardPriceElements = document.querySelectorAll('.pricing-cards .pricing-card .price[data-price-monthly-bgn]')
    cardPriceElements.forEach((el) => {
        priceHandler.updateElementWithPeriodPrices(el, 'monthly')
    })
}

/**
 * Update extra price values for additional requests using original prices from data attributes
 */
function updateExtraPriceValues() {
    const extraPriceElements = document.querySelectorAll('.extra-price-value[data-price-bgn]')

    extraPriceElements.forEach((priceElement) => {
        // Set decimal places to 6 for extra prices
        priceElement.setAttribute('data-decimal-places', '6')

        // Use updateElementWithOriginalPrices which handles time slots
        const updated = priceHandler.updateElementWithOriginalPrices(priceElement)

        if (updated) {
            // Add ~ prefix for extra prices
            const currentText = priceElement.textContent
            if (!currentText.startsWith('~')) {
                priceElement.textContent = '~' + currentText
            }
        }
    })
}

/**
 * Update free plan button state based on billing period
 */
function updateFreePlanButton() {
    const freePlanButton = document.querySelector('.free-plan')
    if (!freePlanButton) return

    const selectedBilling = document.querySelector('input[name="billing_period"]:checked')
    if (!selectedBilling) return

    const isAnnually = selectedBilling.value === 'annually'

    if (isAnnually) {
        freePlanButton.style.opacity = '0.5'
        freePlanButton.style.cursor = 'not-allowed'
        freePlanButton.setAttribute('disabled', true)
    } else {
        freePlanButton.style.cursor = 'pointer'
        freePlanButton.style.opacity = '1'
        freePlanButton.removeAttribute('disabled')
    }
}

/**
 * Prevent clicking on disabled free plan link
 */
function preventDisabledFreePlanClick(event) {
    const freePlanButton = document.querySelector('.free-plan')
    if (!freePlanButton) return

    const isDisabled = freePlanButton.hasAttribute('disabled')
    if (isDisabled) {
        event.preventDefault()
        event.stopPropagation()
        return false
    }
}

/**
 * Update billing period prices based on selected period
 */
function updateBillingPeriodPrices() {
    const monthlyRadio = document.querySelector('input[name="billing_period"][value="monthly"]')
    const annuallyRadio = document.querySelector('input[name="billing_period"][value="annually"]')

    if (!monthlyRadio || !annuallyRadio) return

    const isAnnually = annuallyRadio.checked

    const cardPriceElements = document.querySelectorAll('.pricing-cards .pricing-card .price[data-price-monthly-bgn]')
    const cardPeriodElements = document.querySelectorAll('.pricing-cards .pricing-card .period')
    const cardLinkElements = document.querySelectorAll('.pricing-cards .pricing-card .card-actions a.button')

    cardPriceElements.forEach((el) => {
        // Use updateElementWithPeriodPrices with original prices
        const period = isAnnually ? 'annually' : 'monthly'
        priceHandler.updateElementWithPeriodPrices(el, period)
    })

    cardPeriodElements.forEach((periodElement) => {
        const periodMonthly = periodElement.getAttribute('data-period-monthly')
        const periodAnnually = periodElement.getAttribute('data-period-annually')

        if (isAnnually && periodAnnually) {
            periodElement.textContent = periodAnnually
        } else if (!isAnnually && periodMonthly) {
            periodElement.textContent = periodMonthly
        }
    })

    cardLinkElements.forEach((linkElement) => {
        const link = new URL(linkElement.href)
        link.searchParams.set('billing_cycle', isAnnually ? 'annually' : 'monthly')
        linkElement.href = link.toString()
    })

    // Update free plan button state
    updateFreePlanButton()
}

/**
 * Initialize billing period selector
 */
function initializeBillingPeriodSelector() {
    const billingRadios = document.querySelectorAll('input[name="billing_period"]')

    billingRadios.forEach((radio) => {
        radio.addEventListener('change', updateBillingPeriodPrices)
    })

    // Set initial state
    updateBillingPeriodPrices()
}

/**
 * Initialize server-side GTM plans price handling
 */
function initializeServerSideGtmPlansPrices() {
    // Update all server-side GTM plan prices with dual currency support
    updateServerSideGtmPlansPrices()

    // Update extra price values for additional requests
    updateExtraPriceValues()

    // Initialize billing period selector
    initializeBillingPeriodSelector()

    // Initialize free plan button state
    updateFreePlanButton()

    // Add click prevention for disabled free plan button
    const freePlanButton = document.querySelector('.free-plan')
    if (freePlanButton) {
        freePlanButton.addEventListener('click', preventDisabledFreePlanClick)
    }
}

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', function () {
    initializeServerSideGtmPlansPrices()
})
